import { GQL_EXCHANGE_TYPE } from "@/shared/Disclosure/types/GQL/enum/ExchangeType";
import { API_RES_DISCLOSURE_TYPE } from "@/types/apiModel/Type/API_RES_DISCLOSURE_TYPE";
import { PV_DISCLOSURE_TYPE_ITEM } from "@/types/PresenterModel/PV_DISCLOSURE_TYPE_ITEM";
import createGraphqlClient from "@/utils/createGraphqlClient";

import { gql } from "graphql-request";

const query = (exchangeType: GQL_EXCHANGE_TYPE, isIssuer: boolean) => gql`
  query getDisclosureType {
    getDisclosureType(filter: {
      exchangeType: ${exchangeType}
      isIssuer: ${isIssuer}
    }) {
      exchangeName
      disclosureType
      categoryIds
      isRecommended
      isIssuer
    }
  }
`;

type RequiredFields = "exchangeName" | "disclosureType" | "categoryIds";

type FilteredType = Required<Pick<PV_DISCLOSURE_TYPE_ITEM, RequiredFields>> &
  Exclude<PV_DISCLOSURE_TYPE_ITEM, RequiredFields>;

function filter(item: PV_DISCLOSURE_TYPE_ITEM): item is FilteredType {
  return !!item.exchangeName && !!item.disclosureType && !!item.categoryIds;
}

const parse = async (
  data: API_RES_DISCLOSURE_TYPE
): Promise<PV_DISCLOSURE_TYPE_ITEM[]> => {
  const disclosureTypeList = data?.getDisclosureType || [];

  return disclosureTypeList
    .filter(filter)
    .map((v) => ({ ...v, isRecommended: v.isRecommended ?? false }));
};

const fetchDisclosureType = async (
  exchangeType: GQL_EXCHANGE_TYPE,
  isIssuer?: boolean
) => {
  const client = createGraphqlClient();
  return await parse(
    await client.request(query(exchangeType, isIssuer ?? false))
  );
};

export default fetchDisclosureType;
